'use client';

import {
    Column,
    Columns,
    Icon,
    IconName,
    IconSize,
    Spacer,
    SpacerSize,
    Text,
    Title,
    TitleLevels,
    TypographyBold,
} from '@bytel/trilogy-react';

export type ServiceSectionProps = {
    icon: IconName;
    title: string;
    subtitle: string;
};

function ReinsuranceSection({ icon, title, subtitle }: ServiceSectionProps) {
    return (
        <Column>
            <Columns marginless mobile>
                <Column narrow className='is-narrow-mobile'>
                    <Icon name={icon} size={IconSize.MEDIUM} />
                </Column>
                <Column>
                    <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} marginless>
                        {title}
                    </Text>
                    <Text>{subtitle}</Text>
                </Column>
            </Columns>
        </Column>
    );
}
type ReinsuranceProps = {
    isRenewal: boolean;
};

export function Reinsurance({ isRenewal }: ReinsuranceProps) {
    return (
        <>
            <Title level={TitleLevels.FIVE}>Nos services pour vous accompagner</Title>
            <Spacer size={SpacerSize.SIX} />
            <Columns>
                <ReinsuranceSection
                    title='Paiement sécurisé'
                    subtitle='et données personnelles protégées'
                    icon={IconName.SHIELD_PRIVATE_LIFE}
                />
                <ReinsuranceSection
                    title='Livraison à domicile le lendemain'
                    subtitle='ou livraison express en point relais'
                    icon={IconName.PARCEL_RELAY}
                />
                {!isRenewal && (
                    <ReinsuranceSection
                        title='Un service client disponible'
                        subtitle="par téléphone ou dans l'une de nos 500 boutiques"
                        icon={IconName.ADVISOR}
                    />
                )}
            </Columns>
            <Spacer size={SpacerSize.FOUR} />
        </>
    );
}
